import axios from "axios";
import type { GetOutstandingReceivableParams, OutstandingReceivableItem } from "../dto/receivable.dto";
import { BACKEND_URL } from "../utils/constants";

export const getOutstandingReceivables = async (params: GetOutstandingReceivableParams) => {
  const {
    accountId,
    date,
    type
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.set('accountId', accountId.toString());
  searchParams.set('date', date);
  searchParams.set('type', type);

  const url = `${BACKEND_URL}/reports/receivables/outstanding?${searchParams.toString()}`;
  return axios.get<OutstandingReceivableItem[]>(url).then((res) => res.data);
}
